import React from 'react';
import './FAQ.css';
// import faqBanner from '../assets/logo.png'
import NavBar from '../components/Navbar';
const faqs = [
  {
    question: 'Why is there oil separation in my classic sesame butter?',
    answer: `Our sesame butter is made from 100% pure sesame seeds, with no artificial additives or stabilizers. Sesame seeds naturally have high-fat content, as well as a lot of fiber and protein. Over time, the fat rises to the top and the protein and fiber settle at the bottom. That doesn’t mean that the tahini has gone bad—just mix it well before use.`,
  },
  {
    question: 'How is tahini produced?',
    answer: `Our facility integrates traditional processes with advanced technologies to bring you the best of both worlds. Our sesame arrives from Ethiopia in raw form. We clean and hull the seeds, slow roast them to achieve optimal flavor and aromatics, and stone grind them for an ideal texture.`,
  },
  {
    question: 'Does holland tahini offer organic products?',
    answer: `We aren’t currently able to offer organic products due to the global shortage of high-quality, organic sesame seeds.`,
  },
  {
    question: 'Are holland tahini products gluten-free?',
    answer: `All our products are certified gluten-free by GMP with certification stamps clearly displayed on the packaging.`,
  },
  {
    question: 'Are the nut butters vegan?',
    answer: `Yes! All holland tahini products are vegan and dairy-free.`,
  },
  {
    question: 'Why does holland tahini add palm oil to its sweet spreads? Is it sustainably sourced?',
    answer: `Palm oil is a non-GMO, non-hydrogenated oil that acts as a stabilizer and reduces oil separation. That means less stirring every time you dip into a jar! holland tahini is committed to responsible sourcing of all our ingredients, including our palm oil. We’re proud members of the RSPO (Roundtable on Sustainable Palm), which encourages sustainable growing practices and human rights initiatives at the farm level.`,
  },
  {
    question: 'Why does holland tahini use plastic jars?',
    answer: `We want to make sure that you have the best sesame experience, and glass jars are more susceptible to breakage in production and shipping. Our jars, made from 50% recycled plastic, offer an easy, convenient, and sustainable alternative.`,
  },
  {
    question: 'Is holland tahini a raw food?',
    answer: `Our tahini isn’t raw—we roast the sesame seeds before grinding them. But it is pure—we don’t add any other ingredients to our sesame butter.`,
  },
  {
    question: 'How long does tahini last?',
    answer: `Unopened tahini lasts for up to 24 months when stored in a cool, dry place. `,
  },  
];

const FAQ = () => (
    <>
    <NavBar textColor='#000'/>
  <div className="faq-page">
     
    <h1>FREQUENTLY ASKED QUESTIONS</h1>
    <div className="faq-list">
      {faqs.map((faq, idx) => (
        <details key={idx}>
          <summary>{faq.question}</summary>
          <div className="faq-answer">
            <p>{faq.answer}</p>
          </div>
        </details>
      ))}
    </div>
  </div>
    </>
);

export default FAQ;
